import { Component, Injector } from '@angular/core';
import { NavController, LoadingController, NavParams, ViewController } from 'ionic-angular';
import { Util } from '../../app/util';
@Component({
  selector: 'page-dettaglio',
  templateUrl: 'dettaglio.html'
})
export class DettaglioPage extends Util { 
  prodotto:any = {};
  constructor(public navCtrl: NavController, injector: Injector, loadingCrtl: LoadingController, public navparams: NavParams, public viewCrtl:ViewController) {
    super(injector, loadingCrtl)
    
    this.prodotto = this.navparams.get('prodotto');

  }

  
  chiudi() {
    this.viewCrtl.dismiss();
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/dettaglio/dettaglio.ts